module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAABGdBTUEAALGOfPtRkwAAACBjSFJNAACHDwAAjA8AAP1SAACBQAAAfXkAAOmLAAA85QAAGcxzPIV3AAAACXBIWXMAAAsSAAALEgHS3X78AAABB0lEQVRYR+2WSQ7DIAxFm2v2dFn0lllQbIYQYjyQSqiSK1mdnPD8sT/ZQgivpS8AWBlLF0f1V1bvAK7A/ysQDeyAeDJJU2O47583Lh5CivgZfpsBUQOUapt38PA2EMSqiAhQqo2GfRTThoUZAzdBiABYUZclAACcGoIFaKrHimtyVoC6uFFJ1RcsQFv9JZEBgDwLxBCAaba++aTvbHOyAD9+UiD7QgVQxo1qRuo/Jv9mWiJAull6clB0f94OOp/yCKkH0sKlrwSICkvn27dgdMPOAbsmvAPnfPLMGCoAHlA9/9wCnG0u0vTULbjkU2eF6IQnhO7AseaLADMnnOUaB3AFXIHlCnwBwVG+0DgWdLoAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/res/cpink_4.png
// module id = 57Rg
// module chunks = 1